/**
 * Pull http(s) URLs out of a freeform text body.
 *
 * Deliberately conservative: matches absolute http / https URLs
 * with an authority section. Stops at common terminator characters
 * so trailing punctuation in prose doesn't get folded into the URL
 * (".", ",", ")", etc.). Returns the URLs in the order they
 * appeared, deduped.
 *
 * Caps at MAX_URLS so a single comment with a wall of links
 * doesn't fan out to a wall of preview fetches.
 */

const URL_RE = /https?:\/\/[^\s<>"']+/g;
const TRAILING_PUNCT_RE = /[).,;:!?\]]+$/;
export const MAX_URLS = 4;

export function extractUrls(body: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  const matches = body.match(URL_RE) ?? [];
  for (const raw of matches) {
    const trimmed = raw.replace(TRAILING_PUNCT_RE, "");
    if (!trimmed) continue;
    if (seen.has(trimmed)) continue;
    seen.add(trimmed);
    out.push(trimmed);
    if (out.length >= MAX_URLS) break;
  }
  return out;
}
